<template>
    <!-- <Detail v-if="detail" :detail="detail" @closeDetail="cancelDetail($event)" /> -->
  <section class="course">
    <div class="course__content">
        <h2>Courses</h2>
        <div class="items" v-for="(item) in courses" :key="item.id">
            <div class="items__top">
                <div class="text">
                    <div class="text__round">
                        <h6>{{item.subject}}</h6>
                        <span class="round" @click="show = item.id" :class="{ active: item.id === show }">
                            <img src="@/assets/svg/arr-up.svg" height="24" width="24" alt="">
                        </span>
                    </div>
                    <span>
                        <p>Cost: {{item.cost}}</p>
                        <p>Duration: {{item.duration}} </p>
                    </span>
                </div>
                <span class="round" @click="handleClick(item.id)" :class="{ active: item.id === show }">
                    <img src="@/assets/svg/arr-up.svg" height="24" width="24" alt="">
                </span>
            </div>
            <div class="items__bottom" v-if="show === item.id" >
                <div class="items__bottom__intro">
                    <div>
                        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4.66406 8.16732C4.66406 7.54848 4.90989 6.95499 5.34748 6.5174C5.78506 6.07982 6.37856 5.83398 6.9974 5.83398H20.9974C21.6162 5.83398 22.2097 6.07982 22.6473 6.5174C23.0849 6.95499 23.3307 7.54848 23.3307 8.16732V18.6673H4.66406V8.16732Z" stroke="#D5A48A" stroke-width="3.08333" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M2.33203 22.168H25.6654" stroke="#D5A48A" stroke-width="3.08333" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            <h5><span>Locations:</span> {{ item.course_type }} </h5>
                    </div>
                    <div>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7 12C9.2 12 11 10.2 11 8C11 5.8 9.2 4 7 4C4.8 4 3 5.8 3 8C3 10.2 4.8 12 7 12ZM11 20V14.7C9.9 14.3 8.5 14 7 14C3.1 14 0 15.8 0 18V20H11ZM22 4H15C13.9 4 13 4.9 13 6V18C13 19.1 13.9 20 15 20H22C23.1 20 24 19.1 24 18V6C24 4.9 23.1 4 22 4ZM18 18H16V6H18V18Z" fill="#D5A48A"/>
                            </svg>                            
                        <h5><span>Payment option:</span> {{ item.payment_option }} </h5>
                    </div>
                </div>
        <h6>Course Description:</h6>
        <h2 class="desc">
         {{item.description}}
        </h2>
        <h5><span>Finance Option:</span>  {{item.finance_option}}</h5>
        <div class="split">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M4.5 3.75C4.30109 3.75 4.11032 3.82902 3.96967 3.96967C3.82902 4.11032 3.75 4.30109 3.75 4.5V19.5C3.75 19.6989 3.82902 19.8897 3.96967 20.0303C4.11032 20.171 4.30109 20.25 4.5 20.25H12.375C12.6734 20.25 12.9595 20.3685 13.1705 20.5795C13.3815 20.7905 13.5 21.0766 13.5 21.375C13.5 21.6734 13.3815 21.9595 13.1705 22.1705C12.9595 22.3815 12.6734 22.5 12.375 22.5H4.5C3.70435 22.5 2.94129 22.1839 2.37868 21.6213C1.81607 21.0587 1.5 20.2956 1.5 19.5V4.5C1.5 3.70435 1.81607 2.94129 2.37868 2.37868C2.94129 1.81607 3.70435 1.5 4.5 1.5H19.5C20.2956 1.5 21.0587 1.81607 21.6213 2.37868C22.1839 2.94129 22.5 3.70435 22.5 4.5V13.875C22.5 14.1734 22.3815 14.4595 22.1705 14.6705C21.9595 14.8815 21.6734 15 21.375 15C21.0766 15 20.7905 14.8815 20.5795 14.6705C20.3685 14.4595 20.25 14.1734 20.25 13.875V4.5C20.25 4.30109 20.171 4.11032 20.0303 3.96967C19.8897 3.82902 19.6989 3.75 19.5 3.75H4.5ZM22.92 16.83C23.1307 17.0409 23.249 17.3269 23.249 17.625C23.249 17.9231 23.1307 18.2091 22.92 18.42L19.17 22.17C18.9591 22.3807 18.6731 22.499 18.375 22.499C18.0769 22.499 17.7909 22.3807 17.58 22.17L16.08 20.67C15.9695 20.567 15.8808 20.4428 15.8193 20.3048C15.7578 20.1668 15.7248 20.0178 15.7221 19.8668C15.7194 19.7157 15.7472 19.5657 15.8038 19.4256C15.8604 19.2855 15.9446 19.1583 16.0514 19.0514C16.1583 18.9446 16.2855 18.8604 16.4256 18.8038C16.5657 18.7472 16.7157 18.7194 16.8668 18.7221C17.0178 18.7248 17.1668 18.7578 17.3048 18.8193C17.4428 18.8808 17.567 18.9695 17.67 19.08L18.375 19.785L21.33 16.83C21.5409 16.6193 21.8269 16.501 22.125 16.501C22.4231 16.501 22.7091 16.6193 22.92 16.83ZM7.125 6C6.82663 6 6.54048 6.11853 6.3295 6.3295C6.11853 6.54048 6 6.82663 6 7.125C6 7.42337 6.11853 7.70952 6.3295 7.9205C6.54048 8.13147 6.82663 8.25 7.125 8.25H16.875C17.1734 8.25 17.4595 8.13147 17.6705 7.9205C17.8815 7.70952 18 7.42337 18 7.125C18 6.82663 17.8815 6.54048 17.6705 6.3295C17.4595 6.11853 17.1734 6 16.875 6H7.125ZM6 12C6 11.7016 6.11853 11.4155 6.3295 11.2045C6.54048 10.9935 6.82663 10.875 7.125 10.875H16.875C17.1734 10.875 17.4595 10.9935 17.6705 11.2045C17.8815 11.4155 18 11.7016 18 12C18 12.2984 17.8815 12.5845 17.6705 12.7955C17.4595 13.0065 17.1734 13.125 16.875 13.125H7.125C6.82663 13.125 6.54048 13.0065 6.3295 12.7955C6.11853 12.5845 6 12.2984 6 12ZM7.125 15.75C6.82663 15.75 6.54048 15.8685 6.3295 16.0795C6.11853 16.2905 6 16.5766 6 16.875C6 17.1734 6.11853 17.4595 6.3295 17.6705C6.54048 17.8815 6.82663 18 7.125 18H12.375C12.6734 18 12.9595 17.8815 13.1705 17.6705C13.3815 17.4595 13.5 17.1734 13.5 16.875C13.5 16.5766 13.3815 16.2905 13.1705 16.0795C12.9595 15.8685 12.6734 15.75 12.375 15.75H7.125Z" fill="#D5A48A"/>
            </svg>
            <h5><span>Getting in:</span> {{item.getting_in}}</h5>  
        </div>
            </div>
        </div>
    </div>
    <div class="reviews" id="review">
        <h2>Reviews</h2>
        <div class="reviews__cards">
            <div class="item" v-for="item in review" :key="item.id">
                <h6>
                    Review
                </h6>
                <div class="icon__container">
                    <div class="icon" :class="{icon__active: item.rating >= rate.id}" v-for="rate in rating" :key="rate.id" v-html="rate.icon"></div>
                </div>
                <h5>
                    {{item.review}}
                </h5>
                <p>-{{item.user.name}}</p>
                <h4 class="date">{{item.created_at.slice(0,10)}}</h4>
            </div>
        </div>
    </div>
  </section>
</template>

<script setup>
import {onMounted, ref} from "vue";
import { useStore, mapActions, mapGetters } from "vuex";
import Detail from "./CourseDetail.vue"
const store = useStore()
const props = defineProps(["review", "courses"])
onMounted(async () => {
    mapActions(["Course", "GetReviews"])
    await store.dispatch("Course")
    await store.dispatch("GetReviews")
})
// const courses = ref([
//     {
//         title: "Web Development",
//         cost: "N400,000",
//         duration: "12 Weeks",
//         id: 1,
//         active: false
//     },
//     {
//         title: "Product Design",
//         cost: "N400,000",
//         duration: "12 Weeks",
//         id: 2,
//         active: false
//     },
//     {
//         title: "Data Science",
//         cost: "N400,000",
//         duration: "12 Weeks",
//         id: 3,
//         active: false
//     },
//     {
//         title: "Front-end Development",
//         cost: "N400,000",
//         duration: "12 Weeks",
//         id: 4,
//         active: false
//     },
//     {
//         title: "Backend Development",
//         cost: "N400,000",
//         duration: "12 Weeks",
//         id: 5,
//         active: false
//     },
//     {
//         title: "Cloud Engineer",
//         cost: "N400,000",
//         duration: "12 Weeks",
//         id: 6,
//         active: false
//     },
// ])
const reviews = ref([
    {
        id: 1,
        title: "Overall",
        content: "Attending the Aorthar Design Bootcamp was one of the best decisions I ever made. I knew I wanted to make a career shift into UX, but I didn't want to risk quitting my job to attend a much more expensive full-time bootcamp. Beginex was the perfect part-time solution",
        user: "Adewale Adedamola",
        date: "Feb 21, 2023"
    },
    {
        id: 2,
        title: "Overall",
        content: "Attending the Aorthar Design Bootcamp was one of the best decisions I ever made. I knew I wanted to make a career shift into UX, but I didn't want to risk quitting my job to attend a much more expensive full-time bootcamp. Beginex was the perfect part-time solution",
        user: "Adewale Adedamola",
        date: "Feb 21, 2023"
    },
    {
        id: 3,
        title: "Overall",
        content: "Attending the Aorthar Design Bootcamp was one of the best decisions I ever made. I knew I wanted to make a career shift into UX, but I didn't want to risk quitting my job to attend a much more expensive full-time bootcamp. Beginex was the perfect part-time solution",
        user: "Adewale Adedamola",
        date: "Feb 21, 2023"
    }
])
const rating = ref([
    {
        id: 1,
        active: false,
        icon: `<svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M6 0L7.34708 4.1459H11.7063L8.17963 6.7082L9.52671 10.8541L6 8.2918L2.47329 10.8541L3.82037 6.7082L0.293661 4.1459H4.65292L6 0Z" fill="#FFC100"/> </svg>`
    },
    {
        id: 2,
        active: false,
        icon: `<svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M6 0L7.34708 4.1459H11.7063L8.17963 6.7082L9.52671 10.8541L6 8.2918L2.47329 10.8541L3.82037 6.7082L0.293661 4.1459H4.65292L6 0Z" fill="#FFC100"/> </svg>`
    },
    {
        id: 3,
        active: false,
        icon: `<svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M6 0L7.34708 4.1459H11.7063L8.17963 6.7082L9.52671 10.8541L6 8.2918L2.47329 10.8541L3.82037 6.7082L0.293661 4.1459H4.65292L6 0Z" fill="#FFC100"/> </svg>`
    },
    {
        id: 4,
        active: false,
        icon: `<svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M6 0L7.34708 4.1459H11.7063L8.17963 6.7082L9.52671 10.8541L6 8.2918L2.47329 10.8541L3.82037 6.7082L0.293661 4.1459H4.65292L6 0Z" fill="#FFC100"/> </svg>`
    },
    {
        id: 5,
        active: false,
        icon: `<svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M6 0L7.34708 4.1459H11.7063L8.17963 6.7082L9.52671 10.8541L6 8.2918L2.47329 10.8541L3.82037 6.7082L0.293661 4.1459H4.65292L6 0Z" fill="#FFC100"/> </svg>`
    },
])
const detail = ref(false)
const show = ref()
const cancelDetail = (item) => {
    detail.value = item;
}
const handleClick = (item) => {
    if(item === show.value) {
        show.value = 0
    } else {
        show.value = item;
    }
}
</script>

<style lang="scss" scoped>
.course {
    --gap-space: 1.5rem;
    --space-sm: 1rem;
    --top-space: 0.5rem;
    padding: 0;
    @include flex(space-between, flex-start);
    gap: 1rem;
    @media screen and (max-width: 1380px) {
        flex-wrap: wrap;
        gap: 2rem;
    }
    &__content {
        //width: 100%;
        //flex-grow: 1;
        @media screen and (max-width: 1380px) {
            width: 100%;
        }
        .items {
            width: Min(100%, 691px);
            width: 100%;
            padding: 0.5rem 1.5rem;
            border-left: 5px solid $secondary-80;
            margin: 1rem 0;
            background-color: $white;
            &__top {
                @extend %flex-ac-jb;
            gap: 3rem;
            }
            &__bottom {
                //width: 100%;
                &__intro {
                    width: 100%;
                    @extend %flex-ac-jb;
                    &>div {
                        @extend %flex-ac;
                        gap: 0.5rem;
                    }
                }
                .split {
                    @extend %flex-ac;
                    gap: 0.3rem;
                }
                h6 {
                    font-family: 'Syne', sans-serif;
                    font-style: normal;
                    font-weight: 700;
                    font-size: Max(1.125rem, 18px);
                    line-height: 120%;
                    letter-spacing: -0.045em;
                    color: #263238;
                }
                h5 {
                    font-family: 'Syne', sans-serif;
                    font-style: normal;
                    font-weight: 500;
                    font-size: Max(1.125rem, 18px);
                    line-height: 120%;
                    letter-spacing: -0.045em;
                    color: #263238;
                    margin: 1rem 0;
                    span {
                        font-weight: 700;
                    }
                }
                h2 {
                    font-family: 'Karla', sans-serif;
                    font-style: normal;
                    font-weight: 400;
                    font-size: Max(1.125rem, 18px);
                    line-height: 135%;
                    letter-spacing: -0.015em;
                    color: $black;
                }
            }
        }
            .text {
                // @extend %sh-0;
                width: 100%;
                &__round {
                    @extend %flex-ac-jb;
                    @media screen and (max-width: 620px) {
                        margin-bottom: 1rem;
                    }
                    .round {
                        display: none;
                        @media screen and (max-width: 620px) {
                            display: flex;
                            height: 36px;
                        width: 36px;
                        border-radius: 100%;
                        }
                    }
                }
                h6 {
                    font-family: 'Karla', sans-serif;
                    font-style: normal;
                    font-weight: 700;
                    font-size: Max(1.5rem, 24px);
                    line-height: 133%;
                    letter-spacing: 0.015em;
                    color: #15253F;
                }
                span {
                    @extend %flex-ac;
                    gap: 3rem;
                    p {
                        font-family: 'Karla', sans-serif;
                        font-style: normal;
                        font-weight: 500;
                        font-size: Max(1.25rem, 20px);
                        line-height: 120%;
                        color: #213131;
                        margin-bottom: unset;
                        //flex-shrink: 0;
                        @include respondMax("mobile3x") {
                            flex-shrink: unset;
                        }
                    }
                }
            }
            .round {
                height: 56px;
                width: 56px;
                border-radius: 27px;
                background-color: $secondary-80;
                @extend %flex-ac-jc;
                @extend %sh-0;
                transition: all 0.2s ease-in-out;
                @media screen and (max-width: 620px) {
                    display: none;
                }
                &.active {
                    img {
                        transform: rotate(180deg);
                        transition: all 0.2s ease-in-out;
                    }
                }
            }
    }
    .reviews {
        width: Max(407px, 25.438rem);
        @media screen and (max-width: 1380px) {
            width: 100%;
        }
        h2 {
            font-family: 'Karla', sans-serif;
            font-style: normal;
            font-weight: 700;
            font-size: Max(1.875rem, 18px);
            line-height: Max(2rem, 20px);
            letter-spacing: -0.045em;
            color: $black-50;
            margin-bottom: 1rem;
        }
        &__cards {
            @include flex(flex-start, flex-start);
            flex-wrap: wrap;
            gap: var(--gap-space);
            width: auto;
            @media screen and (max-width: 1360px) {
                flex-wrap: wrap;
            }
            @media screen and (max-width: 969px) {
                justify-content: center;
            }
            .item {
                width: Max(407px, 25.438rem);
                background-color: $white;
                //background: rgba(240, 222, 213, 0.4);
                padding: var(--gap-space);
                @media screen and (max-width: 1380px) {
                    width: 100%;
                }
                h6 {
                    font-family: 'Syne', sans-serif;
                    font-style: normal;
                    font-weight: 400;
                    font-size: Max(1rem, 16px);
                    line-height: 138%;
                    letter-spacing: -0.015em;
                    color: #213131;
                }
                .icon {
                    &__container {
                        @extend %flex-ac;
                        gap: 0.3rem;
                    }
                }
                ::v-deep .icon {
                    display: flex;
                    align-items: center;
                    gap: 0.3rem;
                    svg {
                        margin-bottom: 0.3rem;
                        cursor: pointer;
                        path {
                        // fill: #FFC100;
                        fill: #C4C4C4;
                        }
                    }
                    &__active {
                        svg {
                            path {
                                fill: #FFC100;
                            }
                        }
                    }
                }
                h5 {
                    font-family: 'Karla', sans-serif;
                    font-style: normal;
                    font-weight: 400;
                    font-size: Max(1.25rem, 18px);
                    line-height: 135%;
                    letter-spacing: 0.015em;
                    color: $black;
                    margin: var(--space-sm) 0;
                    padding: var(--top-space);
                    border-top: 1px solid #F0DED5;
                }
                p, .date {
                    font-family: 'Karla', sans-serif;
                    font-style: normal;
                    font-weight: 400;
                    font-size: Max(0.75rem, 12px);
                    line-height: Max(0.75rem, 14px);
                    letter-spacing: 0.015em;
                    color: $black;
                    margin-bottom: unset;
                }
            }
        }
    }
}
</style>